import {ConfigObjectType} from '@wallaby-ui/core';
import {BrowserHistory} from 'history';
import * as React from 'react';

import Layout from './Layout';

interface OwnProps {
  config: ConfigObjectType;
  history: BrowserHistory;
}
type Props = OwnProps;

const LayoutContainer: React.FC<Props> = (props) => {
  const {config, history} = props;
  return <Layout {...props} config={config} history={history} />;
};

LayoutContainer.displayName = 'LayoutContainer';

export default LayoutContainer;
